import "./arrowBar.css";

const ArrowProgressBar = ({ user, isProfile }) => {
  return (
    <>
      <div className="p-0">
        <p className="text-white mb-0 text-18px text-fw-600 text-AktivGrotesk-Bold">
          Level: {user?.level || "0"}
        </p>
        <p className="fs-12 text-fw-400 text-medium-gray">
          {user?.next_level === 0
            ? "Max Level Reached"
            : `${user.next_level_xp} points to reach next level`}
        </p>
        <div className="level-progress-container">
          <div className="level-progress-wrapper">
            <div
              className="level-progress-fill fs-12"
              style={{ width: `${user.current_progress}%` }}
            ></div>
          </div>
        </div>

        <div className="d-space-between fs-12 mt-14px text-light-gray">
          <span>Lvl {user?.level || "0"}</span>
          {!isProfile && (
            <span>
              <span className="text-white">{user?.current_xp}</span>/
              {user?.next_level_xp} XP
            </span>
          )}
          <span>Lvl {user?.next_level || "0"}</span>
        </div>
      </div>
    </>
  );
};

export default ArrowProgressBar;
